
import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

import RequestErrorDialog from "@/components/base/RequestErrorDialog.vue";

import {
  WebchargeSetting,
} from "@/model/WebchargeSetting";

import {
  SettingRequester,
} from "@/scripts/ProfiControlRequests/SettingRequester";

import Vue from "vue";

export default Vue.extend({
  components: {
    RequestErrorDialog,
    FloatingActionButton,
  },
  props: {
    show: Boolean,
    token: String,
    hasEditRights: Boolean
  },
  data: () => ({
    /* Aufstellen eines Arrays mit allen verfügbaren Kalendertagen */
    days: Array.from({length: 31}, (x, i) => (i + 1).toString()),
    tabs: null,
    model: new WebchargeSetting(),
    errors: new Array<string>(),
    valid: true
  }),
  computed: {
    rules() {
      return {
        requiredCondition: (condition: boolean, value: any) => {
          return (!condition || (!!value && value.length > 0)) ? true : this.$t("rules.required");
        }
      }
    },
    canUpdate(): boolean {
      return this.model.hasChanges() && this.valid && this.hasEditRights
    },
    items(): any {
      return [
        {state: this.$t('states.disabled'), value: false},
        {state: this.$t('states.enabled'), value: true}
      ]
    },
    disabledEditRights(): boolean {
      return !this.hasEditRights;
    },
  },
  mounted: function () {
    this.getWebchargeSettings();
  },
  methods: {
    getWebchargeSettings: function () {
      let url = `${this.$config.GatewayUrl}/api/v1/admin/webcharge/configuration/issuer`
      let language = this.$i18n.locale.toString();
      SettingRequester.getWebchargeSettings(url, this.token, this.model, language);
    },
    updateWebchargeSettings: function () {
      let url = `${this.$config.GatewayUrl}/api/v1/admin/webcharge/configuration/issuer`
      let language = this.$i18n.locale.toString();
      SettingRequester.updateWebchargeSettings(url, this.model, this.token, language);
    }
  },
  watch: {
    'model.hasConfigurationError': function () {
      if (!this.model.hasConfigurationError) {
        return;
      }
      this.errors = new Array<string>();
      this.errors = this.model.GetErrorsAsStringArray();
      (this.$refs.errorDialog as any).Show();
      this.model.ResetErrors();
    }
  },
})
